import React from "react";
import { _LandingMenuRoot } from "../LandingMenu.styled";
import Typography from "../../../../Foundation/Typography/Typography";
import Button from "../../../../Foundation/Button/Button";
import { menuMargauxMotinConfig } from "./MenuMargauxMotin.config";
import { _MenuMargauxMotinRoot } from "./MenuMargauxMotin.styled";
import DecorationBox from "../../../DecorationBox/DecorationBox";

interface IMenuMargauxMotinProps {
  title?: string;
  subtitle?: string;
  linkText?: string;
  onClick?: () => void;
}
const MenuMargauxMotin = (props: IMenuMargauxMotinProps) => {
  const { title, subtitle, linkText, onClick } = props;

  return (
    <_MenuMargauxMotinRoot>
      <_LandingMenuRoot className="landing-menu landing-menu__menu js-active">
        <div className="landing-menu__container js-active">
          <div className="menu-margaux-motin-content-wrapper">
            <Typography
              align="center"
              variant={{
                mobile: "h6",
                lg: "h5",
              }}
              style={{
                lineHeight: "124%",
                letterSpacing: "-0.96px",
                marginBottom: "-4px",
              }}
            >
              {title}
            </Typography>

            <Typography
              align="center"
              variant={{ lg: "margaux2", mobile: "margaux3-lg" }}
              color="margauxPink"
            >
              {subtitle}
            </Typography>

            <div style={{ marginTop: 24 }}>
              <Button
                className="btn-classic btn-add js-btn landing-box__button landing-box__button--black"
                $hover={false}
                $color={""}
                onClick={onClick}
              >
                <span className="btn-classic__base">{linkText}</span>
              </Button>
            </div>
          </div>
          {/* Background */}
          <div className="menu-margaux-motin-background-wrapper">
            <div className="menu-margaux-motin-background-wrapper-content">
              {menuMargauxMotinConfig.background}
              <DecorationBox
                imageName="heart"
                styles={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  transform: "translate(-14%, -32%)",
                  mobile: {
                    maxWidth: "136px",
                    transform: "translate(-86%, -22%)",
                  },
                }}
                enableAnimation={true}
                animationType="slideLeft"
                animationDelay={500}
                animationDistance={100}
                threshold={0.4}
              />
              <DecorationBox
                imageName="maki"
                styles={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transform: "translate(-38%, -8%)",
                  mobile: {
                    transform: "translate(182%, -9%)",
                    maxWidth: "78px",
                  },
                }}
                enableAnimation={true}
                animationType="slideRight"
                animationDelay={100}
                animationDistance={500}
                threshold={0.4}
              />
              <DecorationBox
                imageName="uramaki"
                maxWidth="125px"
                styles={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  transform: "translate(55%, -45%)",
                  mobile: {
                    transform: "translate(-132%, 15%)",
                    maxWidth: "90px",
                  },
                }}
                enableAnimation={true}
                animationType="slideLeft"
                animationDelay={100}
                animationDistance={500}
                threshold={0.4}
              />
            </div>
          </div>
        </div>
      </_LandingMenuRoot>
    </_MenuMargauxMotinRoot>
  );
};

export default MenuMargauxMotin;
